import { TRUST_ITEMS } from "@/lib/siteData";

export const TrustMatrix = () => {
  return (
    <section
      data-testid="trust-matrix-section"
      className="relative -mt-16 md:-mt-20 z-20 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl shadow-green-900/10 border border-green-50 px-6 py-8 md:py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {TRUST_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.label}
                data-testid={`trust-item-${i}`}
                className="flex items-start gap-3"
              >
                <div className="shrink-0 w-11 h-11 rounded-xl bg-green-50 text-green-700 flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <div
                    className="font-bold text-green-950 text-sm md:text-base"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {item.label}
                  </div>
                  <div className="text-xs md:text-sm text-slate-500">{item.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustMatrix;
